/**
 * `<DeploymentInfo>` — diskrétní footer s build identitou (#71855, ADR-0026).
 *
 * Zobrazuje verzi aplikace tak, aby Filip / operátor mohl po rollback /
 * deploy vizuálně potvrdit jakou verzi vidí. Renderuje se v pravém dolním
 * rohu app layoutu, malé světlé písmo aby nerušilo UI.
 *
 * Source of truth: `__BUILD_TAG__` + `__BUILD_GIT_SHA__` vstříknuté Vite
 * `define` z Dockerfile build-args (viz `vite.config.ts`, `Dockerfile:32`).
 * V dev módu (`pnpm dev`) zobrazí sentinel `dev / local` — ten je hint
 * že nejde o production build.
 *
 * Tooltip nese plný git SHA (40-char), label krátí na první 7 znaků
 * (běžná git short-SHA konvence).
 *
 * Důvod proč render JEN v AppLayoutu (a ne na login/forgot-password):
 * neautenticated stránky nemají chrome aby nebyl footer rušivý.
 * Operátor po loginu vidí verzi všude.
 */
export function DeploymentInfo() {
  const tag = __BUILD_TAG__;
  const sha = __BUILD_GIT_SHA__;
  const shortSha = sha === 'local' || sha === 'unknown' ? sha : sha.slice(0, 7);

  return (
    <div
      className="mt-8 text-center text-[11px] text-gray-400 dark:text-gray-600"
      title={`Build tag: ${tag}\nGit SHA: ${sha}`}
    >
      <span>
        TENA EDM <strong className="font-medium">{tag}</strong>
        <span className="mx-1.5 text-gray-300 dark:text-gray-700">·</span>
        <span className="font-mono">{shortSha}</span>
      </span>
    </div>
  );
}
